'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    jivo_api?: any;
  }
}

const useJivoChat = (widgetId: string): void => {
  useEffect(() => {
    if (typeof window === 'undefined' || !widgetId) return;

    // Initialize Jivo Chat
    (function (w: Window & { [key: string]: any }, d: Document, s: string) {
      const j = d.createElement(s) as HTMLScriptElement;
      j.async = true;
      j.src = `//code.jivosite.com/widget/${widgetId}`;
      d.head.appendChild(j);
    })(window, document, 'script');
  }, [widgetId]);
};

export default useJivoChat;
